import {BaseHTMLAttributes} from "react";
import {cn} from "@/lib/utils";

export const SectionTitle = ({children, className}: BaseHTMLAttributes<HTMLHeadingElement>) => {
  return (
    <h2 className={cn("text-xl font-medium text-gray-600 mb-1", className)}>
      {children}
    </h2>
  )
}